import { gql, useMutation } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import AccountContentContainer from '../account/AccountContentContainer';
import Button from '../components/Button';
import Buttons from '../components/Buttons';
import type {
  DesktopLoginMutation,
  DesktopLoginMutationVariables,
} from '../graphql/generated/graphqlTypes';

const MUTATION = gql`
  mutation DesktopLogin {
    token: createPasswordToken
  }
`;

const APP_DOWNLOAD_PAGE =
  'https://the.slab.com/posts/slab-desktop-app-beta-2iykq1d2';
const LOADING_WAIT_TIME = 3000;

const getAppLoginUrl = (token: string) => {
  const loginUrl = `${window.location.origin}/magic-link/${token}`;
  return `slab://open-url/${encodeURIComponent(loginUrl)}`;
};

const AppLaunchView = () => {
  const [createToken] = useMutation<
    DesktopLoginMutation,
    DesktopLoginMutationVariables
  >(MUTATION);
  const [isLoading, setIsLoading] = useState(true);
  const [token, setToken] = useState<string>();

  useEffect(() => {
    if (!token) {
      return undefined;
    }

    window.location.href = getAppLoginUrl(token);
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, LOADING_WAIT_TIME);

    return () => clearTimeout(timeout);
  }, [token]);

  useEffect(() => {
    createToken().then(({ data }) => {
      setToken(data?.token);
    });
  }, [createToken]);

  return isLoading || !token ? (
    <AccountContentContainer
      title="Launching Slab…"
      subtitle="We're getting everything set up for you."
    />
  ) : (
    <AccountContentContainer
      title="Launch Slab"
      subtitle="Choose how you'd like to use Slab."
    >
      <Buttons>
        <Button block variant="primary" to={getAppLoginUrl(token)}>
          Open desktop app
        </Button>
        <Button block variant="secondary" to="/">
          Continue using browser version
        </Button>
      </Buttons>
      <hr />
      Still need the app?{' '}
      <a href={APP_DOWNLOAD_PAGE} target="_blank" rel="noreferrer noopener">
        Download Slab
      </a>
    </AccountContentContainer>
  );
};

export default AppLaunchView;
